
import http from '@/api/base'

const queryList = (params) => {
  // params.mockApi = true
  return http.post('/portal/message/queryList', params)
}

const queryMessage = (params) => {
  return http.post('/ipark-web/rest/open/messagepush/queryMessage', params)
}

const selectAppovingDetailByPid = (params) => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return http.post('/portal/message/selectAppovingDetailByPid', params)
}
const selectApprovingDetailByPid = (params) => {
  return http.post('/portal/message/selectApprovingDetailByPid', params)
}

const getRepairType = (params) => {
  return http.post('/portal/repair/getRepairType', params)
}
const modifyRepairType = (params) => {
  return http.post('/portal/repair/modifyRepairType', params)
}

const transfer = (params) => {
  return http.post('/portal/message/transferApp', params)
}
const _submit = (params) => {
  return http.post('/portal/message/stop', params)
}
const submit = (params) => {
  return http.post('/portal/message/submitApp', params)
}
const canRejectNodes = (params) => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return http.post('/portal/message/canRejectNodes', params)
}
const addTaskComment = (params) => {
  return http.post('/portal/message/addTaskComment', params)
}
const reject = (params) => {
  return http.post('/portal/message/reject', params)
}
const saveAttachent = (params) => {
  return http.post('/portal/message/saveAttachent', params)
}
const deleteAttachent = (params) => {
  return http.post('/portal/message/deleteAttachent', params)
}
const getMessageSend = (params) => {
  params.noIpark = true
  return http.post('/ipark-admin/rest/open/messagesend/getMessageSendById', params)
}

const getTaskNodeList = (params) => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return http.post('/portal/message/getTaskNodeList', params)
}
/** 统计数据的接口 */
const businessTypeTop5 = (params) => {
  return http.get('/portal/operatingIndex/businessTypeTop5', {params})
}
const companyStaffTop5 = (params) => {
  return http.get('/portal/operatingIndex/companyStaffTop5', {params})
}
const increaseTrend = (params) => {
  return http.post('/ipark-bigdata/estateBillIncomeStatistics/list', params)
}
const leaseInfo = (params) => {
  return http.get('/portal/operatingIndex/leaseInfo', {params})
}
const parkInfo = (params) => {
  return http.get('/portal/operatingIndex/parkInfo', {params})
}
const refresh = (params) => {
  return http.get('/portal/operatingIndex/refresh', {params})
}
const roomStatus = (params) => {
  return http.get('/portal/operatingIndex/roomStatus', {params})
}

// 首页头部数据统计
const homeQueryList = (params) => {
  return http.post('/ipark-bigdata/indexStatisticsInfo/queryList', params)
}
const getBaseInfo = (params) => {
  return http.post('/portal/homePage/getBaseInfo', params)
}
const getParkInfo = (params) => {
  return http.post('/portal/homePage/getParkResource', params)
}
const getCompanyInfo = (params) => {
  return http.post('/portal/homePage/getHomePageCompany', params)
}

// 首页头部数据统计(支付)
const paymentDataStatistics = (params) => {
  return http.post('/ipark-bigdata/paymentDataStatistics/list', params)
}
// 首次登陆重发登录密码
const resentMessage = (params) => {
  return http.get('/portal/user/resentMessage', {params})
}
// 重设登录密码
const editPassword = (params) => {
  return http.get('/portal/user/editPassword', {params})
}

// 企业名录
const getCompanyList = (params) => {
  return http.post('/portal/company/company/getOrgAttriCompanyListbyPage', params)
}
const getAppNewsList = (params) => {
  // params.loginsession = session.get('loginToken')
  // params.noIpark = true
  return http.post('/ipark-web/rest/open/getAppNewsList', params)
}
const queryStatisticsInfo = (params) => {
  return http.post('/portal/open/company/queryStatisticsInfo', params)
}
const queryCompanyBillsCount = (params) => {
  return http.post('/portal/charge-bill/queryCompanyBillsCount', params)
}
// 查询账单类型
const getContractType = params => {
  return http.post('/portal/charge-bill/getContractType', params)
}
export default {
  resentMessage,
  editPassword,
  queryList,
  queryMessage,
  selectAppovingDetailByPid,
  submit,
  transfer,
  getRepairType,
  modifyRepairType,
  getTaskNodeList,
  businessTypeTop5,
  companyStaffTop5,
  increaseTrend,
  leaseInfo,
  parkInfo,
  refresh,
  roomStatus,
  canRejectNodes,
  addTaskComment,
  reject,
  getMessageSend,
  homeQueryList,
  paymentDataStatistics,
  saveAttachent,
  deleteAttachent,
  selectApprovingDetailByPid,
  _submit,
  getCompanyList,
  getBaseInfo,
  getParkInfo,
  getCompanyInfo,
  getAppNewsList,
  queryStatisticsInfo,
  queryCompanyBillsCount,
  getContractType
}



// WEBPACK FOOTER //
// ./src/area-contract/api/messageService.js